import { FormattedMessage, useIntl } from "react-intl";
import { ChangeEvent, memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

import { CustomTextField } from "../../../components/Inputs/CustomTextField";
import { TooltipLabel } from "../../../components/Tooltips";
import { useDebounce } from "../../../hooks/debounce";

const NameInput = memo(
  ({
    onNameChange,
    error,
  }: {
    onNameChange: (name: string) => void;
    error: string | undefined;
  }) => {
    const intl = useIntl();
    const [inputValue, setInputValue] = useState<string>();

    const debouncedValue = useDebounce(inputValue, 250);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      setInputValue(event.target.value);
    };

    useEffect(() => {
      if (debouncedValue) {
        onNameChange(debouncedValue);
      }
    }, [debouncedValue, onNameChange]);

    return (
      <Box
        sx={{
          marginTop: 1,
          "& .MuiInputBase-root.MuiOutlinedInput-root": { borderRadius: "4px" },
        }}
      >
        <CustomTextField
          identifier="nameBanner"
          label={
            <TooltipLabel
              label={intl.formatMessage({ id: "BANNER_NAME_INPUT_LABEL" })}
              tooltipLabel={intl.formatMessage({
                id: "BANNER_NAME_INPUT_TOOLTIP",
              })}
              translateTooltip={false}
            />
          }
          onChange={handleChange}
          required={false} // set to false, because UI is bugged with tooltip
        />
        {error && (
          <Typography
            sx={{
              color: "error.main",
              fontSize: "0.75rem",
              ml: 1.75,
            }}
          >
            <FormattedMessage id={error} />
          </Typography>
        )}
      </Box>
    );
  }
);

export default NameInput;
